import React from 'react'
import { Link } from 'react-router-dom'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import FloatingMessageUI from '../../../widgets/form/FloatingMessageUI'
import SendEsignConfirmationModalSF from './SendEsignConfirmationModalSF'

const loanSpecificLabel = (loan) => {
  return `${(loan.loanSubType === 'standard' || loan.loanSubType === 'epc') ? 'PO'
    : (loan.loanSubType === 'nbfc' || loan.loanSubType === 'nbfc_vehicle') ? 'NBFC'
      : loan.loanSubType === 'ppa' ? 'PPA'
        : loan.loanSubType === 'vehicle_loan' ? 'EV'
          : loan.loanSubType} terms`
}

const escrowSpecialLabel = (loan) => {
  return (
    loan.escrow !== 'na' && loan.specialTerms ? 'Escrow & Special terms' :
      loan.escrow !== 'na' && !loan.specialTerms ? 'Escrow terms' :
        'Special terms'
  )
}

const sectionTabs = (loan, basePath, page) => {
  if (basePath === 'termSheet') {
    return (
      <div className='g_flex_h g_flex_left g_flex_wrap'>
        <TabLinkUI label='Schedules' to={`/su/loans/${loan.loanId}/termSheet/schedules`} active={page === 'schedules'} />
        <TabLinkUI label='General terms' to={`/su/loans/${loan.loanId}/termSheet/general`} active={page === 'general'} />
      </div>
    )
  }
  if (basePath === 'loanAgreement') {
    return (
      <div className='g_flex_h g_flex_left g_flex_wrap'>
        <TabLinkUI label='General terms' to={`/su/loans/${loan.loanId}/loanAgreement/general`} active={page === 'general'} />
        <TabLinkUI label={loanSpecificLabel(loan)} to={`/su/loans/${loan.loanId}/loanAgreement/loanSpecific`} active={page === 'loanSpecific'} />
        <TabLinkUI label={`${loan.pledgeOrNdu === 'pledge' ? 'Pledge' : 'NDU'} terms`} to={`/su/loans/${loan.loanId}/loanAgreement/pledgeNdu`} active={page === 'pledgeNdu'} />
        {
          !(loan.escrow === 'na' && loan.specialTerms === false) &&
          <TabLinkUI label={escrowSpecialLabel(loan)} to={`/su/loans/${loan.loanId}/loanAgreement/escrowSp`} active={page === 'escrow'} />
        }
        <TabLinkUI label='Schedules' to={`/su/loans/${loan.loanId}/loanAgreement/schedules`} active={page === 'schedules'} />
        <TabLinkUI label='Annexures' to={`/su/loans/${loan.loanId}/loanAgreement/annexures`} active={page === 'annexures'} />
      </div>
    )
  }
  return (
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI
        label='General terms'
        to={`/su/loans/${loan.loanId}/${basePath}/general`}
        active={page === 'general'}
      />
      <TabLinkUI
        label='Schedules'
        to={`/su/loans/${loan.loanId}/${basePath}/schedules`}
        active={page === 'schedules'}
      />
    </div>
  )
}

const canSendForEsign = (loan, documentCode, basePath) => {
  if (basePath === 'termSheet') return false
  const list = loan && loan.agreementSignList ? loan.agreementSignList : []
  const doc = list.filter(d => d.code === documentCode)[0]
  return doc && doc.documentGenerated === true
}

const LoanDocumentSubNavUI = ({
  context, loan, documentCode, basePath, page, onRefreshClick,
  viewDocumentSubmitted, viewDocumentErrorList, onViewDocumentClick,
  successMsg,
  onSendForEsignClick, onSendForEsignCancel, sendForEsignMode,
}) => {
  const isTermSheet = basePath === 'termSheet'
  return (
    <>
      <div className='g_m_top_50'>
        {sectionTabs(loan, basePath, page)}

        <div className='g_m_top_25'>
          <div className='g_flex_h g_flex_right'>
            {
              !isTermSheet &&
              <ButtonTinyWithSpinnerUI
                label='View document'
                onClick={onViewDocumentClick}
                busy={viewDocumentSubmitted}
                disabled={viewDocumentSubmitted}
              />
            }
            {
              isTermSheet &&
              <Link
                to={`/su/loans/${loan.loanId}/termSheet/approval`}
                className='w_btn_tiny'
              >
                Go to Approval →
              </Link>
            }
            {
              canSendForEsign(loan, documentCode, basePath) &&
              <span className='g_m_left_50'>
                <ButtonTinyUI
                  label='Send for eSigning'
                  onClick={onSendForEsignClick}
                  disabled={viewDocumentSubmitted}
                />
              </span>
            }
          </div>
          <FloatingMessageUI errorList={viewDocumentErrorList} success={successMsg} />
        </div>
      </div>

      <div className='g_m_top_100' />

      <SendEsignConfirmationModalSF
        context={context}
        loan={loan}
        documentCode={documentCode}
        isOpen={sendForEsignMode}
        onCancel={onSendForEsignCancel}
        onRefreshClick={onRefreshClick}
      />
    </>
  )
}

export default LoanDocumentSubNavUI
